module.exports = __webpack_public_path__ + "img/sPrincessR_350x350.6287e748.jpg";